module.exports = __webpack_public_path__ + "img/qrcode1.4d8797db.png";